import React from "react";
import { default as WTableHead } from "@mui/material/TableHead";

function TableHead(props) {
  return <WTableHead {...props} />;
}

export default TableHead;
